export default "__VITE_ASSET__DbYX9kUe__"